import { BuildingStateType } from "../utils/network/generated/protoTypes";
import { selectHappinessBuffAmount } from "./selectBuffsInfo";
import { selectAllExistingBuildingInfo } from "./selectExistingBuildingInfo";
export var selectHappinessInfo = function (state) {
    var happiness = selectAllExistingBuildingInfo(state, true).reduce(function (acc, val) {
        if (val.balancing != undefined && val.proto.state !== BuildingStateType.CONSTRUCTING) {
            var stageIdx = (val.proto.stage || 1) - 1;
            var stage = val.balancing.stage[stageIdx];
            var buildingHappiness = stage ? stage.happiness || 0 : 0;
            return acc + buildingHappiness;
        }
        return acc;
    }, 0);
    var happinessBuff = selectHappinessBuffAmount(state, happiness);
    return { happiness: happiness, happinessBuff: happinessBuff };
};
export var selectHappinessAmount = function (state) {
    var happinessInfo = selectHappinessInfo(state);
    return happinessInfo.happiness + (happinessInfo.happinessBuff || 0);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectHappinessInfo.ts
// module id = 549
// module chunks = 3